exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".depart-select[data-v-44713db1]  .el-input{width:100%}", ""]);

// exports
